export const LIGNE_ROB_RESET = "LIGNE_ROB_RESET";
export const LIGNE_ROB_SET_ERROR = "LIGNE_ROB_SET_ERROR";
export const LIGNE_ROB_SET_ITEMS = "LIGNE_ROB_SET_ITEMS";
export const LIGNE_ROB_TOGGLE_LOADING = "LIGNE_ROB_TOGGLE_LOADING";
